import { Utils, C } from '@kineticdata/bundle-common';
import { List, Map, Record } from 'immutable';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/actions');

export const tabLabels = [
  { type: 'Pending', label: 'Pending' },
  { type: 'Completed', label: 'Completed' },
];

export const typeStates = Map({
  Pending: C.CORE_STATE_DRAFT,
  Completed: C.CORE_STATE_SUBMITTED,
});

export const searchFields = [
  {
    id: 'user',
    label: 'Assigned To Me',
    value: `values[${C.FIELD_ASSIGNED_INDIVIDUALS}]`,
    combo: [],
    type: 'checkbox',
  },
  {
    id: 'team',
    label: 'Assigned Team',
    value: `values[${C.FIELD_ASSIGNED_TEAMS}]`,
    combo: [],
    type: 'team',
  },
  {
    id: 'form',
    label: 'Parent Form Name',
    value: `values[${C.FIELD_REQUEST_FORM_NAME}]`,
    combo: [],
    type: 'form',
  },
  {
    id: 'request_id',
    label: 'Submission Id',
    value: `values[${C.FIELD_REQUEST_SUBMISSION_ID}]`,
    combo: [],
  },
  {
    id: 'by',
    label: 'Submitted By',
    value: `values[${C.FIELD_SUBMITTER}]`,
    combo: [],
    type: 'user',
  },
];

export const types = {
  FETCH_ACTIONS_REQUEST: ns('FETCH_ACTIONS_REQUEST'),
  FETCH_ACTIONS_CURRENT: ns('FETCH_ACTIONS_CURRENT'),
  FETCH_ACTIONS_PREVIOUS: ns('FETCH_ACTIONS_PREVIOUS'),
  FETCH_ACTIONS_NEXT: ns('FETCH_ACTIONS_NEXT'),
  FETCH_ACTIONS_SUCCESS: ns('FETCH_ACTIONS_SUCCESS'),
  FETCH_ACTIONS_FAILURE: ns('FETCH_ACTIONS_FAILURE'),
  FETCH_ACTIONS_RESET: ns('FETCH_ACTIONS_RESET'),
  FETCH_ACTIONS_CLEAR: ns('FETCH_ACTIONS_CLEAR'),
  COUNT_ACTIONS_REQUEST: ns('COUNT_ACTIONS_REQUEST'),
  COUNT_ACTIONS_COMPLETE: ns('COUNT_ACTIONS_COMPLETE'),
};

export const actions = {
  fetchActionsRequest: withPayload(types.FETCH_ACTIONS_REQUEST),
  fetchActionsCurrent: noPayload(types.FETCH_ACTIONS_CURRENT),
  fetchActionsPrevious: noPayload(types.FETCH_ACTIONS_PREVIOUS),
  fetchActionsNext: noPayload(types.FETCH_ACTIONS_NEXT),
  fetchActionsSuccess: withPayload(types.FETCH_ACTIONS_SUCCESS),
  fetchActionsFailure: withPayload(types.FETCH_ACTIONS_FAILURE),
  fetchActionsReset: noPayload(types.FETCH_ACTIONS_RESET),
  fetchActionsClear: noPayload(types.FETCH_ACTIONS_CLEAR),
  countActionsRequest: withPayload(types.COUNT_ACTIONS_REQUEST),
  countActionsComplete: withPayload(types.COUNT_ACTIONS_COMPLETE),
};

export const SearchState = Record({
  coreState: C.CORE_STATE_DRAFT,
  query: [],
});

export const State = Record({
  search: SearchState(),
  loading: true,
  error: null,
  data: null,
  limit: 10,
  direction: 'DESC',
  paging: false,
  pageToken: null,
  nextPageToken: null,
  previousPageTokens: List(),
  count: 0,
  countDone: false,
  counts: {},
});

const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_ACTIONS_REQUEST:
      return state
        .set('search', payload ? SearchState(payload) : state.search)
        .set('loading', true)
        .set('error', null)
        .set('data', null)
        .set('limit', (payload && payload.limit) || state.limit)
        .set('direction', (payload && payload.direction) || state.direction)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.FETCH_ACTIONS_CURRENT:
      return state.set('paging', true);
    case types.FETCH_ACTIONS_PREVIOUS:
      return state
        .set('paging', true)
        .set('nextPageToken', null)
        .set('pageToken', state.previousPageTokens.last())
        .update('previousPageTokens', tokens => tokens.pop());
    case types.FETCH_ACTIONS_NEXT:
      return state
        .set('paging', true)
        .update('previousPageTokens', tokens => tokens.push(state.pageToken))
        .set('pageToken', state.nextPageToken)
        .set('nextPageToken', null);
    case types.FETCH_ACTIONS_SUCCESS:
      return state
        .set('loading', false)
        .set('data', List(payload.data))
        .set('error', null)
        .set('paging', false)
        .set('nextPageToken', payload.nextPageToken)
        .set(
          'count',
          payload.count + state.previousPageTokens.size * state.limit,
        )
        .set('countDone', !payload.countPageToken);
    case types.FETCH_ACTIONS_FAILURE:
      return state
        .set('loading', false)
        .set('data', null)
        .set('error', payload.error)
        .set('paging', false);
    case types.FETCH_ACTIONS_RESET:
      return state
        .set('search', SearchState())
        .set('loading', true)
        .set('error', null)
        .set('data', null)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.FETCH_ACTIONS_CLEAR:
      return state
        .set('loading', false)
        .set('error', null)
        .set('data', null)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.COUNT_ACTIONS_COMPLETE:
      return state.update('counts', counts => ({ ...counts, ...payload }));
    default:
      return state;
  }
};

export default reducer;
